import { reactive } from 'vue'

// 创建一个响应式状态存储toast信息
const state = reactive({
  visible: false,
  message: '',
  duration: 3000 // 默认显示3秒
})

// 导出toast服务
export const toastService = {
  // 显示toast
  show(message, duration = 3000) {
    state.visible = true
    state.message = message
    state.duration = duration
    
    // 自动隐藏
    setTimeout(() => {
      this.hide()
    }, duration)
  },
  
  // 隐藏toast
  hide() {
    state.visible = false
    state.message = ''
  },
  
  // 获取当前状态
  getState() {
    return state
  }
} 